import React from "react";

/**
 * Product-fotogalerij voor een presentatie-pagina.
 *
 * Layout:
 *  - Desktop: 2 kolommen met ratio 2:1 (links twee keer zo breed als rechts).
 *  - Hoofdfoto links, spant 2 rijen (grid-row: 1 / 3).
 *  - Twee kleinere foto's rechts, verticaal gestapeld (foto 2 boven, foto 3 onder).
 *  - Mobiel: alle drie foto's onder elkaar, hoofdfoto eerst.
 *
 * Formaat:
 *  - Alle drie containers gebruiken exact dezelfde 1:1 verhouding (aspect-ratio: 1).
 *  - Hoofdfoto = schaal 1, kleine foto's = schaal 0.5 (half breed/hoog t.o.v. hoofd).
 *  - Hoofdfoto NOOIT bijgesneden: object-fit: contain.
 *  - Kleine foto's: object-fit: cover.
 *
 * Props:
 *  - fotos: array van URL-strings (of {url,alt}-objecten). Eerste is hoofd.
 *  - alt:   fallback alt-tekst.
 *  - className: extra classes voor de wrapper.
 */
export function ProductFotoGrid({ fotos = [], alt = "Product", className = "" }) {
  const items = (fotos || []).slice(0, 3).map((f) =>
    typeof f === "string" ? { url: f, alt } : { url: f?.url, alt: f?.alt || alt }
  );
  const [hoofd, klein1, klein2] = items;

  return (
    <div
      className={`product-foto-grid ${className}`}
      data-testid="product-foto-grid"
      style={{
        display: "grid",
        gap: 16,
        gridTemplateColumns: "1fr",
      }}
    >
      {/* Desktop: 2 kolommen 2:1, main spant 2 rijen */}
      <style>{`
        @media (min-width: 768px) {
          .product-foto-grid { grid-template-columns: 2fr 1fr; }
          .product-foto-grid .pfg-main { grid-row: 1 / 3; }
        }
        .product-foto-grid .pfg-cel {
          aspect-ratio: 1 / 1;
          overflow: hidden;
          border-radius: 8px;
          background: rgba(0, 0, 0, 0.04);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .product-foto-grid .pfg-cel img {
          width: 100%;
          height: 100%;
          display: block;
        }
        .product-foto-grid .pfg-main img { object-fit: contain; }
        .product-foto-grid .pfg-thumb img { object-fit: cover; }
      `}</style>

      {hoofd?.url && (
        <div className="pfg-cel pfg-main" data-testid="product-foto-hoofd">
          <img src={hoofd.url} alt={hoofd.alt} loading="lazy" />
        </div>
      )}
      {klein1?.url && (
        <div className="pfg-cel pfg-thumb" data-testid="product-foto-thumb-1">
          <img src={klein1.url} alt={klein1.alt} loading="lazy" />
        </div>
      )}
      {klein2?.url && (
        <div className="pfg-cel pfg-thumb" data-testid="product-foto-thumb-2">
          <img src={klein2.url} alt={klein2.alt} loading="lazy" />
        </div>
      )}
    </div>
  );
}

export default ProductFotoGrid;
